import React, { useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const ReportModal = ({
  show,
  handleClose,
  openFullStatement,
  openTrafficReport,
  openModalFilter,
  reportOptions = [],
  onSubmitReportType,
}) => {
  const [reportType, setReportType] = useState("");

  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmitReportType === "function") {
      onSubmitReportType(reportType);
    } // Pass selected report type to parent

    if (reportType === "statement") {
      openFullStatement(); // ✅ Trigger full statement
    } else if (reportType === "traffic") {
      openTrafficReport(); // ✅ Trigger traffic report
    } else if (reportType === "summary") {
      openModalFilter();
    }

    // handleClose();
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-[1039]"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-2xl shadow-xl w-[380px] sm:w-[450px] p-6 border border-gray-200">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3">
          <h5 className="modal-title main-title font-medium">📊 Report Type</h5>
          <HighlightOffIcon
            onClick={handleClose}
            className="cursor-pointer text-gray-500 hover:text-gray-700"
          />
        </div>

        {/* Body */}
        <form className="mt-4" onSubmit={handleSubmit}>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Report Type
          </label>
          <select
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 text-gray-700"
          >
            <option value="">Select Report</option>
            {/* <option value="statement">Full Statement</option>
            <option value="traffic">Traffic Report</option> */}
            {reportOptions?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {/* Footer */}
          <div className="flex justify-end gap-3 mt-6 border-t pt-4">
            <button
              type="button"
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!reportType}
              className={`px-4 py-2 rounded-lg ${
                reportType
                  ? "bg-cyan-500 text-white hover:bg-cyan-600"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              } transition`}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportModal;
